import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPlaceholder';
/** Renders an SVG icon. */
const SvgPlaceholder = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 6H11a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5M11 4a7 7 0 0 0-7 7v10a7 7 0 0 0 7 7h10a7 7 0 0 0 7-7V11a7 7 0 0 0-7-7z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.293 11.293a1 1 0 0 1 1.414 0l8 8a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414"
      />
    </svg>
  );
};
SvgPlaceholder.displayName = displayName;
export default SvgPlaceholder;
